/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
window.App.Ui.Modals = class Modals {
  constructor() {
    this.openLogin = this.openLogin.bind(this)
    this.openLoginTemp = this.openLoginTemp.bind(this)
    this.openReLoginTemp = this.openReLoginTemp.bind(this)
    this.bindElements = this.bindElements.bind(this)
    this.bindElements()
  }

  isSignedIn() {
    const currentUser = $('meta[name="current-user"]')
    return (
      currentUser &&
      currentUser.attr("content") &&
      currentUser.attr("content").length
    )
  }

  isSignedInTemp() {
    const tempUser = $('meta[name="temp-user"]')
    return (
      tempUser && tempUser.attr("content") && tempUser.attr("content").length
    )
  }

  openLogin(e, option) {
    if ($("#bodyWrapper").data("allowtemp")) {
      return this.openLoginTemp(e, option)
    } else {
      if (!this.isSignedIn()) {
        e.preventDefault()
        $(e.currentTarget).blur()
        $("#modalLogin .header").hide()
        const header = $("#modalLogin .header." + option)
        if (header.length) {
          header.show()
        } else {
          $("#modalLogin .header.default").show()
        }
        if (option === "club") {
          const loginLink = $("#loginLink")[0].href
          $("#loginLink")[0].href = loginLink + "?student_talks=true"
          const registerLink = $("#registerLink")[0].href
          $("#registerLink")[0].href = registerLink + "?student_talks=true"
        }

        return BetterModals.showModal($("#modalLogin"))
      }
    }
  }

  openLoginTemp(e, option) {
    if (!this.isSignedIn() && !this.isSignedInTemp()) {
      e.preventDefault()
      $(e.currentTarget).blur()

      return BetterModals.showModal($("#modalLoginTemp"))
    }
  }

  openReLoginTemp(e, option) {
    e.preventDefault()
    return BetterModals.showModal($("#modalLoginTemp"))
  }

  bindElements() {
    if (!$(".edit_lesson").length) {
      $(document).on(
        "click.loginModal",
        `.customize-this-lesson, \
.lessonsShowView #bodyWrapper input, \
.lessonsShowView button.send-answer, \
.lessonsShowView #bodyWrapper input, \
.lessonsShowView button.send-answer, \
[data-modal='login'], \
.user-only`,
        e => {
          return this.openLogin(e)
        }
      )

      $(document).on(
        "focus.loginModal keyup.loginModals",
        "textarea.thinkfield",
        e => {
          return this.openLogin(e)
        }
      )

      $(document).on(
        "click.loginModals",
        `.startDiscussion.public, .join.public, \
.login-required > div, .login-required > a`,
        e => {
          return this.openLogin(e, "discussion")
        }
      )

      $(document).on("click.loginModals", ".club-form label", e => {
        if (!this.isSignedIn()) {
          return e.preventDefault()
        }
      })

      $(document).on(
        "click.loginModals",
        `.user-only-club, \
[data-form='student_talks'] :input, \
[data-login-popup-application='true']`,
        e => {
          return this.openLogin(e, "club")
        }
      )

      $(document).on(
        "click.loginModals",
        "[data-login-popup-leader='true']",
        e => {
          return this.openLogin(e, "leader")
        }
      )

      $(document).on("click.loginModals", "#new-temp-login", e => {
        return this.openReLoginTemp(e)
      })
    }

    $(document).on("change", "input[name=lesson\\[allow_temp_user\\]]", e => {
      return $("form.edit_lesson").get(0).requestSubmit()
    })

    return $(document).on("click", ".enable-share button", function (e) {
      // hide student options
      $(".access-options").hide()
      $(".edit-notes").hide()
      $(".enable-share").hide()
      // show sharing form
      return $("#share-tools").show()
    })
  }
}

$(document).on("turbo:load", () => new App.Ui.Modals())
